(function () {
  function pushEvent(eventName, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, details || {}));
  }

  function quoteDetails(trigger) {
    return {
      quote_source: trigger.dataset.csnQuoteSource || 'website_cta',
      quote_label: (trigger.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100),
      page_path: window.location.pathname
    };
  }

  document.addEventListener('click', function (event) {
    var quoteTrigger = event.target.closest('a[href*="#cotizar-form"], [data-csn-open-quote]');
    if (quoteTrigger) pushEvent('quote_start', quoteDetails(quoteTrigger));

    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) {
      pushEvent('phone_click', { phone_number: href.replace('tel:', ''), page_path: window.location.pathname });
    } else if (href.indexOf('mailto:') === 0) {
      pushEvent('email_click', { page_path: window.location.pathname });
    } else if (/\.pdf(?:\?|$)/i.test(href) || /cat[aá]logo/i.test(link.textContent || '')) {
      pushEvent('catalog_download', { file_url: href, page_path: window.location.pathname });
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var savesData = navigator.connection && navigator.connection.saveData;
    if (prefersReducedMotion || savesData) {
      document.querySelectorAll('.csn-hero__video').forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.querySelectorAll('source').forEach(function (source) { source.removeAttribute('src'); });
        video.load();
      });
    }

    if (document.querySelector('.csn-construction')) {
      pushEvent('construction_view', { page_path: window.location.pathname });
    }

    if (window.location.hash === '#cotizar-form') {
      var trigger = document.querySelector('[data-csn-open-quote]');
      if (trigger) window.setTimeout(function () { trigger.click(); }, 150);
    }
  });
})();
